import React, {useEffect, useRef, useState} from 'react';

export function useScrollDistance() {
    const [distance, set_distance] = useState(false);

    const handleScroll = () => {
        set_distance(window.scrollY)
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [distance]);
    return distance;
}
